import { Controller } from '@hotwired/stimulus';

export class ConsentController extends Controller {
  static targets = ['preference'];
  static values = {
    consentKey: {
      default: 'consentMode',
      type: String,
    },
    requireConsent: Boolean,
  };

  acceptAll() {
    this.setConsent({
      functional: true,
      advertising: true,
      analytics: true,
    });

    this.close();
  }

  close() {
    this.dispatch('close');
  }

  confirm() {
    this.setConsent(
      [
        'functional',
        'advertising',
        'analytics',
      ].reduce((preferences, preference) => {
        preferences[preference] = this.preferences[preference]?.checked || false;

        return preferences;
      }, {})
    );

    this.close();
    this.dispatch('confirm');
  }

  connect() {
    if (
      !this.requireConsentValue
      || this.currentConsent
    ) {
      return;
    }

    this.open();
  }

  open() {
    this.syncPreferences();

    this.dispatch('open');
  }

  rejectAll() {
    this.setConsent({
      functional: false,
      advertising: false,
      analytics: false,
    });

    this.close();
  }

  setConsent(preferences) {
    const consent = Object.fromEntries(
      Object.entries({
        'ad_personalization': preferences.advertising,
        'ad_storage': preferences.advertising,
        'ad_user_data': preferences.advertising,
        'analytics_storage': preferences.analytics,
        'functionality_storage': preferences.functional,
      }).map(([ type, preference ]) => [
        type,
        preference ? 'granted' : 'denied',
      ])
    );

    if (window.gtag) {
      window.gtag('consent', 'update', consent);
      window.gtag('event', 'consent_updated');
    }

    if (consent['ad_storage'] === 'granted' && consent['analytics_storage'] === 'granted') {
      document.cookie = '__kla_off=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
    } else {
      document.cookie = '__kla_off=true; path=/';
    }

    localStorage.setItem(this.consentKeyValue, JSON.stringify(consent));

    fetch('/cookie-consent', {
      body: JSON.stringify({ consent: consent }),
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });
  }

  syncPreferences() {
    if (!this.hasPreferenceTarget || !this.currentConsent) return;

    Object.entries({
      functional: 'functionality_storage',
      analytics: 'analytics_storage',
      advertising: 'ad_storage',
    }).forEach(([ preference, type ]) => {
      const element = this.preferences[preference];

      if (element) element.checked = this.currentConsent[type] === 'granted';
    });
  }

  get currentConsent() {
    return JSON.parse(localStorage.getItem(this.consentKeyValue));
  }

  get preferences() {
    return this.preferenceTargets.reduce((preferences, preference) => {
      preferences[preference.value] = preference;

      return preferences;
    }, {});
  }
};

